import src from "IMAGE";
export default { src, width: 1658, height: 1658, blurWidth: 0, blurHeight: 0};
